import {
  collection,
  getDocs,
  where,
  getFirestore,
  setDoc,
  query,
  getDoc,
  doc,
  addDoc,
  deleteDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig.js";
const db = getFirestore(firebaseApp);

/**
 * Resolve a dashboard/doctor/business profile after Firebase Auth succeeds.
 * Looks up by email first, then falls back to authID (Auth uid) for docs
 * that were saved without an email field.
 */
export async function getUserProfileByAuth({ email, uid } = {}) {
  const collections = ["dashboardUsers", "doctors", "businesses"];
  const normalizedEmail = email ? String(email).trim().toLowerCase() : null;

  if (normalizedEmail) {
    for (const name of collections) {
      const snap = await getDocs(
        query(collection(db, name), where("email", "==", normalizedEmail))
      );
      if (!snap.empty) {
        const userDoc = snap.docs[0];
        return { ...userDoc.data(), id: userDoc.id };
      }
    }
  }

  if (uid) {
    for (const name of collections) {
      const snap = await getDocs(
        query(collection(db, name), where("authID", "==", uid))
      );
      if (!snap.empty) {
        const userDoc = snap.docs[0];
        return { ...userDoc.data(), id: userDoc.id };
      }
    }
  }

  return null;
}

export async function logAction(eventType, eventAction, user, moreInfo) {
  let newRecord = {
    dateFormatted: new Date().toISOString().substring(0, 10),
    timeFormatted: new Date().toTimeString().substring(0, 8),
    eventType: eventType,
    eventAction: eventAction,
    user: user,
    moreInfo: moreInfo
  };

  try {
    const result = await addDoc(collection(db, "events"), newRecord);
    return {
      success: true,
    };
  } catch (error) {
    console.error("Error adding document: ", error);
    return {
      error: error,
    }
  }
}

export async function sendPushNotificationUser(title, message, fcmToken) {
  const url = "https://sendpushnotificationuser-4woel4f54a-uc.a.run.app";

  const payload = {
    title: title,
    body: message,
    fcmToken: fcmToken,
  };

  try {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await res.json();
    console.log("Response from Cloud Function:", data);
    return {
      success: true,
    };
  } catch (error) {
    console.error("Error calling function:", error);
    return {
      error: error,
    }
  }
}